export interface LegacyUser {
    id: number;
    salutation: string;
    first_name: string;
    last_name: string;
    company_name?: string;
    email: string;
    phone: string;
    last_login_data: number;
    is_active: boolean;
    lang: string;
    role_id: number;
    customer_id: number;
    account_state: string;
    registration_date: number;
    external_id: string;
    country_id: number;
    // following are likely not needed
    selected_location_id?: number;
    allow_cancel_active?: boolean;
    disable_email?: boolean;
    allow_firmware_update?: boolean;
    tracking_enabled?: boolean;
}

export interface LegacyUserStore {
    loading: boolean;
    error: boolean;
    user?: LegacyUser;
}

const USER_STORE = 'userStore';

function useSessionStorage() {
    return {
        clear,
        storeUserData,
        getUserData,
    };

    function clear() {
        console.log('clearing locally stored session information');
        sessionStorage.clear();
    }

    function storeUserData(value: LegacyUserStore) {
        sessionStorage.setItem(USER_STORE, JSON.stringify(value));
    }

    function getUserData(): LegacyUserStore {
        const result = JSON.parse(sessionStorage.getItem(USER_STORE));
        return result as LegacyUserStore;
    }
}

export default useSessionStorage;
